export const AdminPreviewsTab = ({ topPreviews }) => (
  <div className="tacc-card overflow-x-auto" data-testid="admin-previews-table">
    <table className="w-full text-sm min-w-[520px]">
      <thead>
        <tr className="text-left font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] border-b border-[#E7DFD5]">
          <th className="p-4">Rank</th><th className="p-4">Kind</th><th className="p-4">Item</th><th className="p-4 text-right">Plays (30d)</th>
        </tr>
      </thead>
      <tbody>
        {topPreviews.map((p, i) => (
          <tr key={`${p.kind}-${p.id}`} className="border-b border-[#E7DFD5] hover:bg-black/5">
            <td className="p-4 font-mono text-[#78716C]">#{i + 1}</td>
            <td className="p-4 capitalize">{p.kind}</td>
            <td className="p-4 font-mono text-xs text-[#B45309]">{p.id}</td>
            <td className="p-4 text-right font-display text-lg">{p.plays}</td>
          </tr>
        ))}
        {topPreviews.length === 0 && (
          <tr><td colSpan={4} className="p-8 text-center text-[#78716C]">No preview plays yet. Once visitors start listening, top plays show here.</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
